import React, { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Benefits from './components/Benefits';
import Services from './components/Services';
import Payment from './components/Payment';
import Contact from './components/Contact';
import Footer from './components/Footer';
import EclairLanguette from './components/EclairLanguette';

function App() {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        const response = await fetch('/api/tracking/request-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_url: window.location.href
          })
        });
        const data = await response.json();
        if (data.success) {
          localStorage.setItem('tracking_token', data.token);
        }
      } catch (error) {
        console.error('Tracking failed:', error);
      }
    };
    trackVisit();
  }, []);

  return (
    <div className="App font-poppins">
      <Navigation />
      <Hero />
      <About />
      <Benefits />
      <Services />
      <Payment />
      <Contact />
      <Footer />
      <EclairLanguette />
    </div>
  );
}

export default App;
